import { render, staticRenderFns } from "./QuestionnaireRecommend.vue?vue&type=template&id=02165d28&scoped=true"
import script from "./QuestionnaireRecommend.vue?vue&type=script&lang=js"
export * from "./QuestionnaireRecommend.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireRecommend.vue?vue&type=style&index=0&id=02165d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02165d28",
  null
  
)

export default component.exports